<template>
  <div class="main lh-15 c-666">
    <!-- <section class="banner bgs-cover p-r">
      <div class="crumb d-f jc-fs ai-c ff-asl pl-60 in-pc">
        <a class="c-fff" href="/">Home</a><span class="c-fff"></span><a class="c-fff" href="/product">Product</a
        ><span class="c-fff"></span><a class="c-fff ff-as">V1 SERIES RTK ROVER</a>
      </div>
      <div class="banner-content c-fff p-a">
        <div class="p-r w-100p">
          <h1 class="banner-title m-0 lh-13">
            <span class="d-b fw-700">FJD Trion V1<b class="d-ib fw-400 p-r">series</b></span
            ><i class="d-b fw-400">RTK Rover</i>
          </h1>
        </div>
        <a href="/dealer" target="_blank" class="banner-btn d-ib ta-c">Contact Us</a>
      </div>
    </section> -->
    <ProductBanner
      :banner-img="bannerImg"
      :product-name="$t('common.productName.V1')"
      :product-img-style="{ backgroundImage: `url(${bannerProductImg})` }"
    >
      <div class="p-r w-100p">
        <h1 class="banner-title m-0 lh-11">
          <span class="d-b fw-700">
            <span class="tt-u">FJD Trion V1</span>
            <b class="d-ib fw-400 p-r">series</b></span
          ><i class="d-b fw-500 lh-15 tt-u">RTK Rover</i>
        </h1>
      </div>
    </ProductBanner>

    <!-- banner:end -->
    <div class="content p-r z-3 bgc-fff">
      <div class="nav-anchor z-99 l-0 w-100p bgc-fff c-333">
        <div class="h-100p m-a d-f jc-sb ai-c fs-16">
          <strong class="d-f ai-c fs-20 fw-500"
            >FJD Trion V1 Series RTK Rover<span class="in-h5 triangle-icon triangle-icon-fff bgs-cover bgp-c"></span
          ></strong>
          <div class="d-f">
            <div class="nav-anchor-item d-f jc-sb ai-c">
              <a href="#overview">Overview</a>
              <a href="#feature">Features</a>
              <nuxt-link to="/product/trion-v1-series-rtk-rover-specs">SPECs</nuxt-link>
            </div>
            <a class="dealer-free-quote-btn d-ib ta-c bgc-222 c-fff in-pc" href="/basicinfo" target="_blank"
              >Free Quote</a
            >
          </div>
        </div>
      </div>
      <!-- nav-anchor:end -->
      <section class="area-1">
        <div class="w-12r m-a">
          <ul class="d-f jc-sb fw-w">
            <li class="reveal">
              <i
                ><img
                  width="100%"
                  height="100%"
                  alt="Global Constellation Coverage"
                  src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h136v136H0z'/%3E%3Cg transform='translate(9.459 9.298)' stroke='%23FFF' stroke-width='2'%3E%3Cellipse transform='rotate(30 59.456 59.442)' cx='59.456' cy='59.442' rx='42.539' ry='42.5'/%3E%3Cellipse transform='rotate(30 59.87 59.68)' cx='59.87' cy='59.681' rx='17.181' ry='42.5'/%3E%3Cpath d='M30.077 28.604c-9.542-2.218-16.438-1.763-18.551 1.897-4.395 7.613 13.56 26.209 40.106 41.535C78.177 87.362 103.26 93.614 107.655 86c2.035-3.525-.722-9.404-6.904-16.223'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
              /></i>
              <span>Global Constellation <br />Coverage</span>
            </li>
            <li class="reveal">
              <i
                ><img
                  width="100%"
                  height="100%"
                  alt="Tilt Survey (V1t) 30°, 2.5cm"
                  src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h136v136H0z'/%3E%3Cg transform='translate(25.642 21)'%3E%3Cellipse stroke='%23FFF' stroke-width='2' cx='26.748' cy='15.505' rx='25.748' ry='14.505'/%3E%3Cpath d='M1.707 16.08c8.765 1.913 17.301 2.87 25.61 2.87 8.31 0 16.467-.957 24.472-2.87' stroke='%23FFF' stroke-width='2'/%3E%3Cpath d='M26.748 25.267c.629 0 1.139-.514 1.139-1.148 0-.634-.51-1.149-1.139-1.149-.628 0-1.138.515-1.138 1.149s.51 1.148 1.138 1.148zM33.578 24.693c.628 0 1.138-.514 1.138-1.148 0-.635-.51-1.149-1.138-1.149-.629 0-1.139.514-1.139 1.149 0 .634.51 1.148 1.139 1.148zM19.919 24.693c.629 0 1.138-.514 1.138-1.148 0-.635-.51-1.149-1.138-1.149-.629 0-1.138.514-1.138 1.149 0 .634.51 1.148 1.138 1.148z' fill='%23FFF'/%3E%3Cpath d='M23.334 29.287l.07 70.75a1.142 1.142 0 0 0 1.139 1.139h4.553a1.137 1.137 0 0 0 1.137-1.138l-.07-70.75' stroke='%23FFF' stroke-width='2'/%3E%3C/g%3E%3Cpath d='M70.845 46.62c2.758 4.809 7.636 9.615 13.977 13.276 12.661 7.31 26.36 7.287 30.597-.053 4.237-7.339-2.592-19.214-15.252-26.523-9.465-5.465-19.51-6.831-25.749-4.107' stroke='%23FFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='3.343541039684438,2.865892319729518'/%3E%3Cpath d='M77.433 40.457c4.489 3.548 9.1 6.687 13.832 9.42a104.865 104.865 0 0 0 22.628 9.749' stroke='%23FFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='3.343541039684438,2.865892319729518'/%3E%3Cpath d='M87.613 55.063a1.143 1.143 0 0 0 1.56-.426c.317-.55.133-1.25-.411-1.564a1.143 1.143 0 0 0-1.56.426c-.317.55-.133 1.25.411 1.564zM93.815 57.98a1.143 1.143 0 0 0 1.56-.426c.317-.549.133-1.25-.412-1.563a1.143 1.143 0 0 0-1.56.425c-.317.55-.133 1.25.412 1.564zM81.986 51.15a1.143 1.143 0 0 0 1.56-.425c.317-.55.133-1.25-.412-1.564a1.143 1.143 0 0 0-1.56.426c-.317.55-.132 1.25.412 1.564z' fill='%23FFF'/%3E%3Cpath d='M82.514 58.409l-26.485 44.53.101 13.483 31.79-55.06' stroke='%23FFF' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='3.343541039684438,2.865892319729518'/%3E%3Cpath d='M56.251 88.037c2.944-.48 5.312.125 7.106 1.812M43.528 72.758C28.312 75.368 18 80.415 18 86.213c0 5.757 10.166 10.774 25.204 13.399m30.16 1.826c24.261-.947 43.032-7.402 43.032-15.225 0-6.17-11.673-11.488-28.506-13.925' stroke='%23FFF' stroke-width='2' stroke-linecap='round'/%3E%3C/g%3E%3C/svg%3E"
              /></i>
              <span>Tilt Survey (V1t)<br />30°, 2.5cm</span>
            </li>
            <li class="reveal">
              <i
                ><img
                  width="100%"
                  height="100%"
                  alt="Fast Start, Fixed Seconds"
                  src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h136v136H0z'/%3E%3Cpath d='M68.5 112c22.368 0 40.5-18.132 40.5-40.5S90.868 31 68.5 31 28 49.132 28 71.5c0 2.948.315 5.822.913 8.59M56.337 22.523L79 22.5' stroke='%23FFF' stroke-width='2' stroke-linecap='round'/%3E%3Cg stroke='%23FFF' stroke-linecap='round' stroke-width='2'%3E%3Cpath d='M29 88.62l28-.028M35.379 99.493h21.62M44.027 110.395H57'/%3E%3C/g%3E%3Cpath stroke='%23FFF' stroke-width='2' stroke-linecap='round' d='M97.183 41.65l10.497-10.433M102.874 24.78l11.464 11.464'/%3E%3Cpath stroke='%23FFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M67.925 52.25V71.1l13.15 13.15'/%3E%3C/g%3E%3C/svg%3E"
              /></i>
              <span>Fast Start, <br />Fixed Seconds</span>
            </li>
            <li class="reveal">
              <i
                ><img
                  width="100%"
                  height="100%"
                  alt="15-Hour Battery Life"
                  src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath stroke='%23FFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M99.5 45h10V35'/%3E%3Cpath d='M108.534 44.468C100.507 31.013 85.806 22 69 22c-25.405 0-46 20.595-46 46s20.595 46 46 46c18.314 0 34.128-10.702 41.53-26.194' stroke='%23FFF' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M82 82.5V90a4 4 0 0 1-4 4H53a4 4 0 0 1-4-4V49a4 4 0 0 1 4-4h25a4 4 0 0 1 4 4v8.5' stroke='%23FFF' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M59 45v-5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v5' stroke='%23FFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cg stroke='%23FFF' stroke-linecap='round' stroke-width='2'%3E%3Cpath d='M56 57.5h19M56 65.5h11M56 73.5h11M56 81.5h19'/%3E%3C/g%3E%3Cg fill='%23FFF'%3E%3Cpath d='M70 66.554V63.11L72.742 61h3.094v16.734h-3.094V64.518zM78.553 73.878v-.364h2.834v.146c0 .518.158.921.475 1.212.314.291.747.437 1.299.437.597 0 1.042-.199 1.334-.594.292-.397.436-.974.436-1.733v-1.263c0-.792-.144-1.378-.436-1.758-.292-.378-.745-.569-1.359-.569-.786 0-1.348.378-1.678 1.14H78.79V61h8.812v2.716h-6.144V67.5c.63-.518 1.402-.775 2.316-.775 1.37 0 2.407.417 3.108 1.248.701.832 1.05 2.025 1.05 3.58v1.573c0 1.537-.42 2.733-1.263 3.59-.843.857-2.013 1.285-3.508 1.285-1.42 0-2.54-.364-3.367-1.09-.827-.727-1.241-1.738-1.241-3.032M104 77.734h-3.097v-7.081h-5.41v7.081h-3.096V61h3.096v6.889h5.41V61H104z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
              /></i>
              <span>15-Hour <br />Battery Life</span>
            </li>
            <li class="reveal">
              <i
                ><img
                  width="100%"
                  height="100%"
                  alt="IP67"
                  src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h136v136H0z'/%3E%3Cg fill='%23FFF' fill-rule='nonzero'%3E%3Cpath d='M42.52 73.57V54.812h3.076V73.57zM56.12 54.813c2.124 0 3.76.527 4.912 1.58 1.152 1.052 1.727 2.365 1.727 3.94 0 1.573-.544 2.905-1.632 3.993-1.089 1.089-2.757 1.633-5.006 1.633h-3.4v7.61h-3.077V54.813h6.477zm-3.4 8.744h3.4c1.17 0 2.043-.279 2.618-.836.576-.558.864-1.336.864-2.335 0-.998-.288-1.776-.864-2.334-.575-.558-1.448-.837-2.617-.837h-3.4v6.342zM76.388 67.12c0-1.206-.32-2.173-.958-2.902-.639-.728-1.543-1.093-2.712-1.093-1.17 0-2.137.329-2.902.985-.764.657-1.146 1.606-1.146 2.848 0 1.24.355 2.226 1.065 2.955.711.728 1.67 1.093 2.875 1.093s2.136-.351 2.793-1.053c.656-.702.985-1.646.985-2.834zM72.61 55.973c-1.422 0-2.483.544-3.185 1.633-.702 1.088-1.07 2.892-1.106 5.41.467-.791 1.151-1.403 2.05-1.835a6.647 6.647 0 0 1 2.915-.647c1.8 0 3.257.575 4.372 1.727 1.116 1.151 1.673 2.712 1.673 4.682 0 1.97-.566 3.567-1.7 4.79-1.133 1.224-2.717 1.835-4.75 1.835-2.788 0-4.704-.935-5.748-2.806-.54-.936-.917-2.002-1.133-3.198-.216-1.197-.324-2.622-.324-4.278 0-6.584 2.32-9.877 6.963-9.877 1.799 0 3.216.486 4.25 1.457 1.035.972 1.642 2.168 1.822 3.59h-2.834c-.396-1.656-1.484-2.483-3.265-2.483zM82.082 53.977H95.09v2.294l-7.503 17.298h-3.373l7.853-17.028h-9.985z'/%3E%3C/g%3E%3Cpath d='M26 34.194L68 21l42 13.194V58.15c0 26.25-16.915 49.553-41.995 57.85C42.921 107.703 26 84.394 26 58.14V34.194z' stroke='%23FFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E"
              /></i>
              <span>IP67</span>
            </li>
            <li class="reveal">
              <i
                ><img
                  width="100%"
                  height="100%"
                  alt="CM Accuracy"
                  src="data:image/svg+xml,%3Csvg width='136' height='136' viewBox='0 0 136 136' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h136v136H0z'/%3E%3Cg transform='translate(23 23)' stroke='%23FFF'%3E%3Ccircle stroke-width='2' cx='45' cy='45' r='8.878'/%3E%3Cpath d='M45 17.561c-15.154 0-27.439 12.285-27.439 27.439S29.846 72.439 45 72.439c13.859 0 25.317-10.274 27.176-23.621' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M57.738 69.308a27.6 27.6 0 0 0 4.155-2.686 27.346 27.346 0 0 0 10.248-17.59 27.48 27.48 0 0 0-1.24-13.114m-10.03-13.31a27.435 27.435 0 0 0-13.128-4.91 27.346 27.346 0 0 0-19.636 5.68c-11.942 9.33-14.06 26.573-4.73 38.515' stroke-linecap='round' stroke-dasharray='2.203448394249226,3.103448275862069'/%3E%3Cpath d='M54.71 1.05A45.164 45.164 0 0 0 45 0C20.147 0 0 20.147 0 45s20.147 45 45 45 45-20.147 45-45' stroke-width='2' stroke-linecap='round'/%3E%3Cpath stroke-width='2' d='M79.767 17.852L54.731 38.798'/%3E%3Cpath stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M54.57 31.332l.129 7.405 7.41-.13M79.512 25.075l.259-7.4-7.406-.26'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
              /></i>
              <span>CM <br />Accuracy</span>
            </li>
          </ul>
        </div>
      </section>
      <!-- area-1:end -->
      <section class="area-2">
        <div class="w-12r m-a" id="overview">
          <h2 class="ta-c">A New Way To Measure The World</h2>
          <div class="desc">
            FJD Trion V1 series, a versatile and lightweight GNSS RTK receiver, can fast deliver accurate positions in
            harsh environments with global signal coverage. V1t, the advanced version, is engineered with an Inertial
            Measurement Unit (IMU) that frees you up from watching and leveling the bubble when measuring.
          </div>
          <div class="video-box from-bottom">
            <video
              width="100%"
              height="100%"
              x5-playsinline
              x5-video-player-type="h5"
              x-webkit-airplay="allow"
              playsinline
              webkit-playsinline
              muted
              preload="none"
              loop
              autoplay
              controls
              src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/4b9102a9387702304830512834/dr63gHRmvUAA.mp4"
              poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/4b9102a9387702304830512834/sampleSnapshot/sampleSnapshot_10_0.jpg"
            ></video>
          </div>
        </div>
      </section>
      <!-- area-2:end -->
      <section class="area-3">
        <div class="w-12r m-a">
          <h2 class="ta-c">Application Scenarios</h2>
          <ul class="d-f jc-sb fw-w ai-fs">
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-3-1.jpg')"
                data-original="@/assets/images/trion-v1-series-rtk-rover/area-3-1.jpg"
                data-m-original="@/assets/images/trion-v1-series-rtk-rover/area-3-1-m.jpg"
                alt="Road"
              />
              <strong class="d-b p-a">Road</strong>
            </li>
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-3-2.jpg')"
                data-original="@/assets/images/trion-v1-series-rtk-rover/area-3-2.jpg"
                data-m-original="@/assets/images/trion-v1-series-rtk-rover/area-3-2-m.jpg"
                alt="Precision Agriculture"
              />
              <strong class="d-b p-a">Precision Agriculture</strong>
            </li>
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-3-3.jpg')"
                data-original="@/assets/images/trion-v1-series-rtk-rover/area-3-3.jpg"
                data-m-original="@/assets/images/trion-v1-series-rtk-rover/area-3-3-m.jpg"
                alt="Construction"
              />
              <strong class="d-b p-a">Construction</strong>
            </li>
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-3-4.jpg')"
                data-original="@/assets/images/trion-v1-series-rtk-rover/area-3-4.jpg"
                data-m-original="@/assets/images/trion-v1-series-rtk-rover/area-3-4-m.jpg"
                alt="Resource Exploration"
              />
              <strong class="d-b p-a">Resource Exploration</strong>
            </li>
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-3-5.jpg')"
                data-original="@/assets/images/trion-v1-series-rtk-rover/area-3-5.jpg"
                data-m-original="@/assets/images/trion-v1-series-rtk-rover/area-3-5-m.jpg"
                alt="Digital Machinery"
              />
              <strong class="d-b p-a">Digital Machinery</strong>
            </li>
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-3-6.jpg')"
                data-original="@/assets/images/trion-v1-series-rtk-rover/area-3-6.jpg"
                data-m-original="@/assets/images/trion-v1-series-rtk-rover/area-3-6-m.jpg"
                alt="Marine"
              />
              <strong class="d-b p-a">Marine</strong>
            </li>
          </ul>
        </div>
      </section>
      <!-- area-3:end -->
      <section class="area-4">
        <div class="w-12r m-a" id="feature">
          <h2 class="ta-c">Tilt Survey With Built-in IMU</h2>
          <div class="desc ta-c">
            IMU supported tilt survey will provide a more convenient and efficient measurement. Make you throw away the
            trouble of leveling.
          </div>
          <div class="img-box from-bottom">
            <video
              width="100%"
              height="100%"
              x5-playsinline
              x5-video-player-type="h5"
              x-webkit-airplay="allow"
              playsinline
              webkit-playsinline
              muted
              preload="none"
              loop
              autoplay
              src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/9104fe32387702305074566824/EFjelqRLJJAA.mp4"
              poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/9104fe32387702305074566824/sampleSnapshot/sampleSnapshot_10_0.jpg"
            ></video>
          </div>
        </div>
      </section>
      <!-- area-4:end -->
      <section class="area-5">
        <div class="w-12r m-a">
          <h2 class="ta-c">Guaranteed Waterpoof</h2>
          <div class="desc ta-c">
            The V1 series has passed the IP 67 rating and the intensive test of 1.5 m drop resistance, which will fit
            the measurement work of more and more users.
          </div>
          <div class="img-box from-bottom">
            <video
              width="100%"
              height="100%"
              x5-playsinline
              x5-video-player-type="h5"
              x-webkit-airplay="allow"
              playsinline
              webkit-playsinline
              muted
              preload="none"
              loop
              autoplay
              src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/bd948db1387702305078217943/a5XaXbp3v1YA.mp4"
              poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/bd948db1387702305078217943/sampleSnapshot/sampleSnapshot_10_0.jpg"
            ></video>
          </div>
        </div>
      </section>
      <!-- area-5 -->
      <section class="area-6">
        <div class="w-12r m-a p-r ov-h d-f jc-sb fd-r ai-c" id="download">
          <div class="left-img p-r">
            <i class="line in-pc p-a d-b"
              ><img
                width="100%"
                height="100%"
                src="data:image/svg+xml,%3Csvg width='854' height='193' viewBox='0 0 854 193' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 192.5h571L854 1' stroke='%23BFBFBF' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E"
                alt="line"
            /></i>
            <span class="d-b p-a light"></span>
            <img
              class="lazy-image"
              v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-6-1.png')"
              data-m-original="@/assets/images/trion-v1-series-rtk-rover/area-6-1-m.png"
              width="100%"
              height="100%"
              alt="FJD Trion Survey"
            />
          </div>

          <div class="right-content area-6-swiper-in-h5">
            <div class="swiper-wrapper">
              <div class="right-content-text-1 swiper-slide">
                <h2>FJD Trion Survey</h2>
                <div class="desc">
                  Trion Survey is an app that aids engineers in accurate measurement. It works with FJD Field Controller
                  and other Android devices for effortless survey experiences. It supports internal/external radio and
                  works with CORS stations to satisfy varied needs. The concise interface and easy-to-understand icons
                  make the measurement intuitive more than ever.
                </div>
                <ul class="right-icon d-f jc-sb">
                  <li>
                    <i
                      ><img
                        v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-6-icon-4.png')"
                        width="100%"
                        height="100%"
                        alt="Point Survey"
                    /></i>
                    <span>Point Survey</span>
                  </li>
                  <li>
                    <i
                      ><img
                        v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-6-icon-3.png')"
                        width="100%"
                        height="100%"
                        alt="Point S.O."
                    /></i>
                    <span>Point S.O.</span>
                  </li>
                  <li>
                    <i
                      ><img
                        v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-6-icon-2.png')"
                        width="100%"
                        height="100%"
                        alt="Line S.O."
                    /></i>
                    <span>Line S.O.</span>
                  </li>
                  <li>
                    <i
                      ><img
                        v-lazy="require('@/assets/images/trion-v1-series-rtk-rover/area-6-icon-4.png')"
                        width="100%"
                        height="100%"
                        alt="Road S.O."
                    /></i>
                    <span>Road S.O.</span>
                  </li>
                </ul>
                <!-- <a href="" class="download-btn d-f ai-c jc-c">
                  <i><img width="100%" height="100%" src="data:image/svg+xml,%3Csvg width='34' height='34' viewBox='0 0 34 34' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(1 1)' fill='none' fill-rule='evenodd'%3E%3Crect stroke='%23FFF' stroke-width='1.143' width='32' height='32' rx='5.815'/%3E%3Cg transform='translate(6.11 4.847)'%3E%3Cellipse stroke='%23FFF' stroke-width='1.143' cx='9.891' cy='6.005' rx='9.821' ry='6.005'/%3E%3Cpath d='M0 5.978c3.435 1.211 6.78 1.817 10.036 1.817 3.257 0 6.453-.606 9.59-1.817' stroke='%23FFF' stroke-width='1.143'/%3E%3Cpath d='M9.89 10.189a.434.434 0 1 0 0-.87.434.434 0 0 0-.432.435c0 .24.193.435.433.435zm2.599-.218c.24 0 .433-.194.433-.435a.434.434 0 0 0-.433-.435.434.434 0 0 0-.433.435c0 .24.194.435.433.435zm-5.197 0c.24 0 .433-.194.433-.435a.434.434 0 0 0-.433-.435.434.434 0 0 0-.433.435c0 .24.194.435.433.435z' fill='%23FFF' fill-rule='nonzero'/%3E%3C/g%3E%3Cpath stroke='%23FFF' stroke-width='1.143' stroke-linecap='round' stroke-linejoin='round' d='M14.546 16.909l.364 11.449h2.18l.364-11.45'/%3E%3Cpath d='M15.338 8.456c.054.308.132.607.265.895l-.038-.03a.218.218 0 0 0-.12-.05c-.046-.004-.093-.013-.139-.019-.062-.008-.102-.04-.12-.093a2.965 2.965 0 0 1-.1-.38 14.08 14.08 0 0 1-.074-.415c-.01-.061-.014-.123-.02-.185l-.027-.3a7.531 7.531 0 0 1-.018-.269c-.006-.133-.01-.267-.014-.4v-.028l.07-.027a3.086 3.086 0 0 1 1.097-.174c.299.007.587.06.864.16l.103.039-.024.361-.032-.012a2.684 2.684 0 0 0-.603-.18 2.283 2.283 0 0 0-.528-.03c-.2.013-.391.053-.576.122l-.028.01c-.019.085-.002.587.024.688a2.507 2.507 0 0 1 1.19.01l-.004.042-.017.172a.09.09 0 0 1-.006.026c-.014.033-.041.05-.081.047-.03-.002-.058-.008-.087-.013a2.207 2.207 0 0 0-.465-.04 2.194 2.194 0 0 0-.468.066l-.024.007' fill='%23FFF' fill-rule='nonzero'/%3E%3Cpath d='M16.73 7.573l.059.014c.084.02.167.046.247.077.031.013.032.013.03.042l-.022.29c-.004.054-.01.109-.013.163a4.561 4.561 0 0 1-.182.965 3.604 3.604 0 0 1-.382.854 2.32 2.32 0 0 1-.4.489c-.025.023-.052.045-.08.069l-.084-.074a2.222 2.222 0 0 1-.348-.413 3.228 3.228 0 0 1-.241-.434 5.693 5.693 0 0 1-.071-.162.05.05 0 0 1-.005-.027l.043.038a.266.266 0 0 0 .144.058l.147.015a.14.14 0 0 1 .113.072c.035.06.069.12.106.177.053.082.112.16.178.233l.019.02.022-.025c.127-.143.228-.3.313-.466a3.793 3.793 0 0 0 .386-1.542l.019-.413.002-.02' fill='%23FFF' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E" alt="download"></i>
                  <span>
                    <b>Download</b>
                    <em>For Android</em>
                  </span>
                </a> -->
              </div>
              <div class="right-content-text-2 swiper-slide">
                <h2>FJD Trion <br />Field Controller E200</h2>
                <div class="desc">
                  E200 controller streamlines your construction workflow with its study and durable housing,
                  industrial-grade three proofings, and a high-brightness display that allows for sunlight
                  readability.<br />
                  <ul>
                    <li>5-inch screen</li>
                    <li>7000 mAh, 24h battery life</li>
                    <li>CPU 2.4Ghz</li>
                    <li>Memory 4+64 GB</li>
                    <li>USB- Type C, OTG Support</li>
                    <li>1.5-meter drop test survivor</li>
                    <li>IP67</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="area-6-pagination-in-h5"></div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'
  import bannerScroll from '@/mixins/bannerScroll.js'
  import ProductBanner from '@/components/ProductBanner'
  export default {
    components: {
      ProductBanner
    },
    mixins: [bannerScroll],
    data() {
      return {
        bannerImg: require('@/assets/images/trion-v1-series-rtk-rover/banner.jpg'),
        bannerProductImg: require('@/assets/images/trion-v1-series-rtk-rover/banner-pic.png')
      }
    },
    head() {
      return {
        title: 'FJD Trion V1 series RTK Rover',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'FJD Trion V1 series RTK Rover'
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'FJD Trion V1 series, a versatile and lightweight GNSS RTK receiver, can fast deliver accurate positions in harsh environments with global signal coverage. V1t, the advanced version, is engineered with an Inertial Measurement Unit (IMU) that frees you up from watching and leveling the bubble when measuring.'
          }
        ]
      }
    },
    created() {},
    mounted() {
      // eslint-disable-next-line nuxt/no-env-in-hooks
      if (process.browser) {
        gsap.registerPlugin(ScrollTrigger)
        this.anim1()
        this.anim2()
        this.anim3()
        // this.loadVideoPlay('area4-video1')
      }
    },
    methods: {
      anim1() {
        gsap.from('.area-6 .right-content', {
          y: '20%',
          opacity: 0,
          duration: 0.3,
          scrollTrigger: {
            trigger: '.area-6',
            start: '0% 60%',
            end: '+=0',
            // markers: true,
            scrub: 1
          }
        })
      },

      anim2() {
        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.area-6',
              start: '15% 50%',
              end: '+=700',
              // markers: true,
              scrub: 1
            }
          })
          .from('.area-6 .left-img', {
            x: '10%',
            duration: 0.3,
            opacity: 0
          })
          .from('.area-6 .light', {
            duration: 0.1,
            opacity: 0
          })
          .from('.area-6 .line', {
            duration: 0.2,
            width: 0
          })
          .from('.area-6 .right-icon li', {
            stagger: 0.2,
            duration: 0.2,
            opacity: 0,
            transform: 'scale(0.7) translateY(100%)'
          })
          .from('.download-btn', {
            duration: 0.3,
            y: '200%'
          })
      },

      anim3() {
        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.area-6',
              start: '50% 50%',
              end: '+=500',
              // markers: true,
              scrub: 1
            }
          })
          .to('.area-6 .line', {
            duration: 0.1,
            width: 0
          })
          .to('.area-6 .light', {
            duration: 0.1,
            opacity: 0,
            animation: 'none'
          })
          .to('.right-content-text-1', {
            duration: 0.15,
            y: '-110%'
          })
          .to('.right-content-text-2', {
            duration: 0.15,
            top: 0,
            opacity: 1
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  @media screen and (min-width: 768px) {
    .fs-40 {
      font-size: 0.4rem;
    }
    .fs-20 {
      font-size: 0.2rem;
    }
    .fs-18 {
      font-size: 0.18rem;
    }
    .fs-16 {
      font-size: 0.16rem;
    }
    h2 {
      font-size: 0.48rem;
      color: #333;
    }

    .main {
      margin-top: 0.76rem;
    }

    /* banner */
    .banner {
      height: 8rem;
      background-image: url('@/assets/images/trion-v1-series-rtk-rover/banner.jpg');
    }
    .banner .crumb {
      padding-top: 0.34rem;
      font-size: 0.16rem;
      display: flex;
      align-items: center;
      line-height: 1;
    }
    .banner .crumb span {
      height: 0.13rem;
    }
    .banner .crumb a:hover {
      color: #fff;
    }
    .banner-content {
      left: 2rem;
      top: 3.29rem;
    }
    .banner-title span {
      font-size: 0.64rem;
    }
    .banner-title i {
      font-size: 0.48rem;
      font-weight: 500;
    }
    .banner-title b {
      width: 0.8rem;
      line-height: 0.3rem;
      text-align: center;
      margin-left: -0.08rem;
      top: -0.34rem;
      font-size: 0.2rem;
      border-radius: 0.14rem 0.14rem 0.14rem 0;
      background-color: rgba(0, 0, 0, 0.4);
    }
    .banner-btn {
      margin-top: 0.48rem;
      font-size: 0.24rem;
      width: 1.62rem;
      line-height: 0.52rem;
      background: rgba(255, 255, 255, 0.65);
      transition: background-color 0.3s linear;
    }
    .banner-btn:hover {
      background: rgba(255, 255, 255, 0.75);
    }

    /* nav-anchor */
    .nav-anchor {
      height: 0.56rem;
      top: 0.76rem;
      position: sticky;
      box-shadow: 0px 0.02rem 0.04rem 0px rgba(0, 0, 0, 0.1);
    }
    .nav-anchor > div {
      padding-left: 1.6rem;
      padding-right: 1.6rem;
    }
    .nav-anchor a {
      margin-left: 0.8rem;
    }
    .nav-anchor .nav-anchor-item a:hover {
      font-weight: 700;
    }
    .nav-anchor .dealer-free-quote-btn {
      width: 1.2rem;
      line-height: 0.32rem;
      transition: background-color 0.3s linear;
    }
    .nav-anchor .dealer-free-quote-btn:hover {
      color: #fff;
      background-color: rgba(34, 34, 34, 0.85);
    }

    /* area-1 */
    .area-1 {
      height: 6.88rem;
      background-attachment: fixed;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url('@/assets/images/trion-v1-series-rtk-rover/area-1.jpg?v');
    }
    .area-1 ul {
      padding: 0.3rem 0 0 0;
    }
    .area-1 li {
      width: 1.9rem;
      margin: 0.7rem 1.05rem 0;
    }
    .area-1 li i {
      display: block;
      margin: 0 auto;
      width: 1.36rem;
      height: 1.36rem;
      margin-bottom: 0.08rem;
    }
    .area-1 li span {
      display: block;
      text-align: center;
      font-size: 0.2rem;
      color: #fff;
    }

    /* area-2 */
    .area-2 {
      padding-top: 1.2rem;
    }
    .area-2 .desc {
      margin: 0.24rem 0 0.32rem;
    }
    .area-2 .video-box {
      height: 6.75rem;
    }
    /* area-3 */
    .area-3 {
      padding-top: 1.6rem;
    }
    .area-3 h2 {
      margin-bottom: 0.32rem;
    }
    .area-3 li {
      width: 3.92rem;
    }
    .area-3 li strong {
      bottom: 0.2rem;
      left: 0.24rem;
      color: #fff;
      font-weight: 500;
      font-size: 0.24rem;
    }
    .area-3 li:nth-child(1) {
      height: 2.4rem;
    }
    .area-3 li:nth-child(2) {
      height: 4.74rem;
    }
    .area-3 li:nth-child(3) {
      height: 2.4rem;
    }
    .area-3 li:nth-child(4) {
      height: 4.74rem;
      margin-top: -2.22rem;
    }
    .area-3 li:nth-child(5) {
      height: 2.4rem;
      margin-top: 0.12rem;
    }
    .area-3 li:nth-child(6) {
      height: 4.74rem;
      margin-top: -2.22rem;
    }
    /* area-4 / area-5 */
    .area-4,
    .area-5 {
      padding-top: 1.6rem;
    }
    .area-4 .desc,
    .area-5 .desc {
      margin: 0.24rem auto 0.32rem;
    }
    .area-4 .img-box,
    .area-5 .img-box {
      height: 6.75rem;
    }
    .area-5 .desc {
      width: 8.96rem;
    }

    /* area-6 */
    .area-6 {
      height: 300vh;
      padding-top: 1.6rem;
      padding-bottom: 1.6rem;
    }
    .area-6 > div {
      position: sticky;
      top: 1.6rem;
    }
    .area-6 .right-content {
      width: 5.75rem;
      flex: 0 0 auto;
      position: relative;
      overflow: hidden;
      height: 5.92rem;
    }
    .area-6 h2 {
      padding-top: 0.32rem;
    }
    .area-6 .desc {
      margin: 0.24rem 0 0.42rem;
    }
    .area-6 .right-content-text-1 ul {
      padding: 0 0.2rem 0 0.05rem;
      position: relative;
      overflow: hidden;
    }
    .area-6 .right-content-text-1 ul li {
      position: relative;
    }
    .area-6 .right-content-text-1 li i {
      display: block;
      width: 0.81rem;
      height: 0.81rem;
      margin: 0 auto;
    }
    .area-6 .right-content-text-1 li span {
      display: block;
      margin-top: 0.2rem;
      font-size: 0.16rem;
      text-align: center;
    }
    .area-6 .right-content-text-2 ul {
      padding-top: 0.1rem;
    }
    .area-6 .right-content-text-2 li {
      list-style-type: disc;
      list-style-position: inside;
    }
    .area-6 .download-btn {
      margin-top: 0.75rem;
      width: 1.66rem;
      height: 0.5rem;
      background: rgba(38, 38, 38, 1);
      color: #fff;
    }
    .area-6 .download-btn:hover {
      background-color: rgba(38, 38, 38, 0.9);
    }
    .area-6 .download-btn i {
      width: 0.34rem;
      height: 0.34rem;
      display: block;
      margin-right: 0.12rem;
    }
    .area-6 .download-btn b {
      font-size: 0.2rem;
      display: block;
      font-weight: 500;
      line-height: 1;
      margin-bottom: 0.04rem;
    }
    .area-6 .download-btn em {
      font-size: 0.12rem;
      display: block;
      line-height: 1;
    }
    .area-6 .right-content-text-2 {
      position: absolute;
      top: 100%;
      opacity: 0;
    }
    .area-6 .left-img {
      width: 5.92rem;
      height: 5.92rem;
      flex: 0 0 auto;
    }
    .area-6 .left-img i {
      overflow: hidden;
      transition: width, opacity 0.5s linear;
      width: 8.54rem;
      height: 1.93rem;
      top: 2.71rem;
      right: 3.35rem;
    }
    .area-6 .left-img i img {
      display: block;
      transition: width, opacity 0.5s linear;
      position: absolute;
      top: 0;
      right: 0;
      width: 8.54rem;
      height: 1.93rem;
    }
    .area-6 .left-img .light {
      width: 0.4rem;
      height: 0.4rem;
      top: 2.52rem;
      right: 3.2rem;
      animation: light 1.5s linear infinite;
      background: url('@/assets/images/trion-v1-series-rtk-rover/area-6-icon-light.png') no-repeat center / cover;
    }
    @keyframes light {
      0% {
        opacity: 0.2;
        transform: scale(0.9);
      }
      20% {
        opacity: 0.3;
        transform: scale(1);
      }
      40% {
        opacity: 0.6;
        transform: scale(1.1);
      }
      60% {
        opacity: 0.9;
        transform: scale(1.2);
      }
      80% {
        opacity: 0.6;
        transform: scale(1.1);
      }
      100% {
        opacity: 0.3;
        transform: scale(1);
      }
    }
  }
  // new - bannerImg
  // .banner-product-img {
  //   width: 3.41rem;
  //   height: 2.8rem;
  //   top: 5.01rem;
  //   right: 2.59rem;
  //   background-image: url('@/assets/images/trion-v1-series-rtk-rover/banner-pic.png');
  // }
  :deep(.banner-product-img) {
    top: 5rem;
    right: 2.59rem;
    width: 3.41rem;
    height: 2.8rem;
  }
</style>
